import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

/**
 * Shared layout state. On mobile (<= 991px) the persistent sidenav is hidden
 * and the nav bar's hamburger opens the same menu as a slide-in drawer —
 * this service lets the two layout components talk to each other.
 */
@Injectable({providedIn: 'root'})
export class LayoutService {
  private readonly sidenavVisibleSubject = new BehaviorSubject<boolean>(false);
  readonly sidenavVisible$ = this.sidenavVisibleSubject.asObservable();

  get sidenavVisible(): boolean {
    return this.sidenavVisibleSubject.value;
  }

  openSidenav(): void { this.sidenavVisibleSubject.next(true); }
  closeSidenav(): void { this.sidenavVisibleSubject.next(false); }
  toggleSidenav(): void { this.sidenavVisibleSubject.next(!this.sidenavVisibleSubject.value); }
}
